module.exports = __webpack_public_path__ + "img/pic_2.77f0eb5a.jpg";